module.exports = "/_next/static/images/9f6413820b4ed56209e44637dce0bffc-woman-playing-with-her-kids@sm.jpg.webp";